import { FC } from 'react';

import { PromoRollSynthJobFieldsFragment } from '@entities/PromoRollSynthJob/model';
import styles from './PromoRollSynthJobCard.module.scss';

type Props = {
  job: PromoRollSynthJobFieldsFragment;
};

const PromoRollSynthJobCard: FC<Props> = ({ job }) => (
  <div className={styles.card}>
    <span className={styles.title}>{`${job.title}.mp3`}</span>
  </div>
);

export default PromoRollSynthJobCard;
